import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Link } from "../../../library-js/dom-tools/LinkResolver";
import { EmailValidator } from "../../../library-js/validators/EmailValidator";
import { Request } from "../../../library/ts/html/server/Request";
import { ClassFilter } from "../cookie-settings/DocSearchSettings";
import { Overlay } from "../overlay/Overlay";
import { OverlayHint, OverlayHintOptions } from "../overlay/OverlayHint";
import { Rokojori } from "../Rokojori";

export class PartyInfo
{
  email:string;
  name:string;
  persons:number;
  key:string;
}

export class UpdatePartyInvitations
{
  static readonly url = "_php/party.php";
  static readonly type = new ElementType( "party-invitation" );
  static readonly email = new ClassFlag( "email" );
  static readonly _name = new ClassFlag( "name" );
  static readonly persons = new ClassFlag( "persons" );
  static readonly partyRequest = new ClassFlag( "party-request" );

  static applyOnDocument()
  {
    UpdatePartyInvitations.type.forAllInDoc( e => UpdatePartyInvitations.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let button = UpdatePartyInvitations.partyRequest.query( e ) as HTMLElement;
    
    OnClick.add( button, 
      async ( ev )=>
      {
        let em = ( UpdatePartyInvitations.email.query( e ) as HTMLInputElement ).value;
        let nm = ( UpdatePartyInvitations._name.query( e ) as HTMLInputElement ).value;
        let pe = ( UpdatePartyInvitations.persons.query( e ) as HTMLSelectElement ).value; 
        let ky = new URLSearchParams( window.location.search ).get( "key" );

        let options = new OverlayHintOptions();
        options.isCancable = false;

        
        if ( nm == "" || /^\s+$/.test( nm ) || nm.length < 3  )
        {
          console.log( "Name ba:", em );
          let content = 
          
          `
          Is' das dein richtiger Name: "${nm}" ?!<br><br>
          
          Vielleicht doch lieber etwas klangvolleres?

          <br><br>
          Falls es wieder nicht klappt, gib' uns kurz Bescheid!
          
          `

          let contentNode = ElementType.span.create();
          contentNode.innerHTML = content;

          
          OverlayHint.hint( "Name!", contentNode, options );   
    
          return;
        }

        console.log( "Name good:", nm );


        if ( em == "" || ! EmailValidator.isValid( em ) )
          {
            console.log( "Email bad:", em );
           let content = 
            
            `
            Da is was schief gelaufen!<br><br>
            
            Hier wird behauptet die Email, sei nicht gut? <br>
            Könntest du das nochmal überprüfen?
  
            <br><br>
            Falls es wieder nicht klappt, gib' uns kurz Bescheid!
            
            `
  
            let contentNode = ElementType.span.create();
            contentNode.innerHTML = content;
  
            
            OverlayHint.hint( "Email!", contentNode, options );   
      
            return;
          }
  
          console.log( "Email good:", em );
  

        if ( ky == null || ky == undefined || ky == "" || ky == "undefined" || ky =="null" )
        {
          console.error( "Error Sending" );
          
         let content = 
          
          `
         Da gab's wohl ein Fehler!<br><br>
          
          Hast du den richtigen Link verwendet? <br>
          Der sollte mit einem Key im Link sein.

          <br><br>
          Versuche es später nochmal oder gib' uns kurz Bescheid!
          
          `

          let contentNode = ElementType.span.create();
          contentNode.innerHTML = content;

          
          OverlayHint.hint( "Huch!", contentNode, options );   
    
          return;
        }

        console.log( em, pe, ky );

        try
        {
          let result = await UpdatePartyInvitations.send( { email: em, name: nm, persons: parseInt( pe ), key:ky } );

          console.log( result );
          let thanksContent = 
            
          `
            Du solltest gleich eine Email erhalten, die dir nochmal bestätigt,
            dass das geklappt hat.

            Wir freuen uns!
          
          `

          let thanksNode = ElementType.span.create();
          thanksNode.innerHTML = thanksContent;


          OverlayHint.hint( "Vielen Dank!", thanksNode, options );   
        }
        catch ( e )
        {
          let errorContent = 
            
          `
            Da ist was gehörig schief gelaufen auf dem Server!
            Sorry, das Senden hat wahrscheinlich nicht geklappt.

            <br><br>
            Versuche es später nochmal.
            <br><br>
            Bitte melde dich bei uns, falls es weiter hin nicht geht.
          
          `

          let errorNode = ElementType.span.create();
          errorNode.innerHTML = errorContent;


          OverlayHint.hint( "Oh Oh!", errorNode, options ); 
        }
        

        // 
      }
    );
  }

  static async send( info:PartyInfo )
  {
    let link = Link.Root( "" );
    let relativeURL = Rokojori.$.pageHandler.createRelativeLink( link ).path + UpdatePartyInvitations.url;
    let result = await Request.post( relativeURL, info );

    return Promise.resolve( result );
    // console.log( result );
  }
}